module.exports = __webpack_public_path__ + "static/media/Regulador-03.73964e5c.png";